// extracted by mini-css-extract-plugin
export default {"title":"CreateUser_title__T3UTA","form":"CreateUser_form__JOM11","saveModal":"CreateUser_saveModal__gwmPt"};